
import React from 'react';

interface AccessStatusMessageProps {
  isAuthenticated: boolean;
  userEmail?: string | null;
}

const AccessStatusMessage: React.FC<AccessStatusMessageProps> = ({ isAuthenticated, userEmail }) => {
  if (isAuthenticated) {
    return (
      <p className="text-sm text-gray-600">
        Your account (<strong>{userEmail}</strong>) does not have beta access permissions.
        If you believe this is an error, please contact support.
      </p>
    );
  }
  
  return (
    <p className="text-sm text-gray-600">
      You need to have an account with beta access permissions to use this application.
    </p>
  );
};

export default AccessStatusMessage;
